module.exports = __webpack_public_path__ + "img/W-29.e6c91863.jpg";